import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { useTranslation } from '../../../src/i18n';
import Title from '../../Title';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1),
  },
}));

const TitleBlock = ({ className, title, subtitle }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={cn(classes.root, className)}>
      <Title size="big" style={{ fontWeight: 'bold' }}>
        {t(title)}
      </Title>
      <div>
        <Title size="medium">{t(subtitle)}</Title>
      </div>
    </div>
  );
};

TitleBlock.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default memo(TitleBlock);
